import React, {Component, PropTypes} from 'react';
import {Button, Modal} from '@sketchpixy/rubix';

class ContractRegisterModal extends Component {
  render() {
    return (
        <Modal
            show={this.props.showModal}
            onHide={this.props.closeModal}
            backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Active contract exists</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>
              {this.props.email} user's active contract exists.
            </h4>
            <h4>
              Would you like to register a new contract?
            </h4>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.props.buttonClickHandler.bind(this, false)}>No</Button>
            <Button bsStyle="brownishgray" onClick={this.props.buttonClickHandler.bind(this, true)}>
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
    );
  }
}

ContractRegisterModal.propTypes = {
  email: PropTypes.string.isRequired,
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  buttonClickHandler: PropTypes.func.isRequired,
};

export default ContractRegisterModal;



// WEBPACK FOOTER //
// ./src/routes/payment/ContractRegisterModal/ContractRegisterModal.js